export default from './AddRecipe';




/** WEBPACK FOOTER **
 ** ./app/components/addRecipe/index.js
 **/